import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-power-monitoring',
  templateUrl: './power-monitoring.component.html',
  styleUrls: ['./power-monitoring.component.scss']
})
export class PowerMonitoringComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
